import StatCard from '@/components/base/StatCard';
import Reveal from '@/components/feature/Reveal';
import PerformanceBoundary from '@/components/feature/PerformanceBoundary';
import DataFreshness from './DataFreshness';

const METRIC_ICONS: Record<string, string> = {
  'total-return': 'ri-percent-line',
  'win-rate': 'ri-trophy-line',
  'profit-factor': 'ri-scales-3-line',
  'max-dd': 'ri-arrow-down-double-line',
};

const VALUE_TONE: Record<string, string> = {
  'avg-win': 'text-primary-700',
  'avg-loss': 'text-secondary-500',
};

export default function StatOverview() {
  return (
    <section id="overview" className="py-14 md:py-20 bg-background-50 scroll-mt-32 md:scroll-mt-36">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-shell mx-auto">
          <PerformanceBoundary label="account statistics">
            {(data) => (
              <>
                <Reveal>
                  <DataFreshness snapshot={data.accountSnapshot} />
                </Reveal>

                <div className="mt-5 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
                  {data.headlineMetrics.map((metric, index) => (
                    <Reveal key={metric.id} delay={index * 70} className="h-full">
                      <StatCard
                        label={metric.label}
                        value={metric.value}
                        caption={metric.caption}
                        tone={metric.tone}
                        icon={METRIC_ICONS[metric.id]}
                      />
                    </Reveal>
                  ))}
                </div>

                <Reveal delay={120}>
                  <div className="mt-4 md:mt-6 rounded-lg border border-background-200 overflow-hidden">
                    <div className="flex items-center gap-2.5 bg-background-100 px-4 md:px-5 py-3.5">
                      <span className="w-7 h-7 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                        <i className="ri-bar-chart-box-line text-sm" aria-hidden="true"></i>
                      </span>
                      <h2 className="font-heading text-sm font-semibold text-foreground-950">
                        Trade statistics
                      </h2>
                      <span className="hidden sm:inline text-xs text-foreground-500">
                        — the numbers behind the track record
                      </span>
                    </div>

                    <dl className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-px bg-background-200">
                      {data.detailMetrics.map((metric) => (
                        <div key={metric.id} className="bg-background-50 p-3 sm:p-4">
                          <dt className="text-[11px] sm:text-xs text-foreground-500 truncate">{metric.label}</dt>
                          <dd
                            className={`mt-1.5 sm:mt-2 font-num text-base sm:text-lg md:text-xl font-bold ${
                              VALUE_TONE[metric.id] ?? 'text-foreground-950'
                            }`}
                          >
                            {metric.value}
                          </dd>
                        </div>
                      ))}
                    </dl>
                  </div>
                </Reveal>
              </>
            )}
          </PerformanceBoundary>
        </div>
      </div>
    </section>
  );
}